export default __webpack_public_path__ + "static/hosting-b4018cc10ac175b511dc05f2d7391be4.jpeg";